var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CContainer',[_c('CRow',[_c('router-view',{attrs:{"account":this.account},on:{"updateAccount":function($event){return _vm.updateAccount()}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }